<template>
<div class="chapter">
<div class="inner_page">
<div id="excerpt">
<h2>This one time, Seona’s heart commanded.</h2>
<p class="noindent">Just this one time to be with him. This one time to love him, fully and completely. This one time to grasp a life’s worth of happiness.<br/><br/></p>
<p class="noindent">“Love me, Griffydd,” she pleaded fervently. “Love me now. Tonight.”<br/><br/></p>
<p class="noindent">“We will be married,” he promised as he reached out for her.<br/><br/></p>
<p class="noindent">She smiled at this honorable man who would not take what she was offering without some kind of promise between them.<br/><br/></p>
<p class="noindent">“I will always be yours,” she replied softly, and truthfully, hoping it would be enough.<br/><br/></p>
<p class="noindent">It had to be, for there was no more she could say.<br/><br/></p>
<p class="noindent">“I love you with all my heart, wife-to-be,” he murmured, pressing feather-light kisses upon her forehead and cheeks. “I am yours forever.”<br/><br/></p>
<p class="noindent">“Shh,” she hushed, afraid that if he called her “wife” again she would start to weep. “Later. We will speak of these things later.”<br/><br/></p>
<p class="noindent">Even though she knew full well that there could be no later for them.<br/><br/></p>
<p class="noindent">All they would ever have was this one time.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003-excerpt.vue?06cf34f3